import React from 'react';
import './machine&deep-learning.css';

const m_meet = () => {
    return (
        <div className="m_meet__wrap">
            <div className="m_meet container">
                <h3 className="m_meet--title">You Will Meet</h3>
                    <ul className='m_meet--list'>
                        <li className='m_meet--list_item inner_pages--text'>Top speakers and practitioners in Machine Learning and Deep Learning</li>
                        <li className='m_meet--list_item inner_pages--text'>Data Scientists and Data Analysts</li>
                        <li className='m_meet--list_item inner_pages--text'>Decision makers</li>
                        <li className='m_meet--list_item inner_pages--text'>Software Developers focused on Machine Learning and Deep Learning</li>
                        <li className='m_meet--list_item inner_pages--text'>Data Science Innovators</li>
                        <li className='m_meet--list_item inner_pages--text'>CEOs, CTOs, CIOs</li>
                        <li className='m_meet--list_item inner_pages--text'>Industry leaders</li>
                        <li className='m_meet--list_item inner_pages--text'>Core contributors in the fields of Machine Learning and Deep Learning</li>
                        <li className='m_meet--list_item inner_pages--text'>Data Science Enthusiasts</li>
                    </ul>
            </div>
        </div>
    );
};

export default m_meet;